<template lang="html">
  <div class="item-description-wrapper" @click="$emit('details')">
    <div class="description-title">
      <div class="title">{{ description.pro_name }}</div>
      <div class="user">{{ description.usr_name }}</div>
    </div>
    <!-- end title -->
    <div class="details">
      <div class="description-expire">
        <span class="description-offer">{{ $t("item.offerStands") }}</span>
        <span class="description-expire-date">{{
          $moment
            .utc(description.pro_expiry)
            .local()
            .format("YYYY-MM-DD HH:mm")
        }}</span>
      </div>
      <div class="description-user">
        <div v-if="description.rating" class="description-rate-wrapper">
          <span class="rate-title">{{ $t("item.rate") }}:</span>
          <span class="rate">{{ description.rating.toFixed(1) }}</span>
        </div>
      </div>

      <div class="description-prices ">
        <div class="description-price">
          <span class="range">{{ $t("item.currentlyReserved") }}</span>
          <span class="price">{{
            description.off_count
              .toLocaleString("en")
              .split(",")
              .join(".")
          }}</span>
        </div>
        <div class="description-price">
          <span class="range">{{ $t("item.currentPrice") }}</span>
          <span class="price"
            >{{
              description.current_price
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            {{ description.cur_id }}</span
          >
        </div>
      </div>
    </div>
    <!-- end details -->
    <div class="main">
      <div
        class="description-price"
        v-for="(price, index) in description.prices"
        :key="index"
      >
        <span class="price"
          >{{
            price.price
              .toLocaleString("en")
              .split(",")
              .join(".")
          }}
          <span>{{ description.cur_id }}</span></span
        >
        <span class="range"> / </span>
        <span
          v-if="price.min === price.max || (price.min === 0 && price.max === 1)"
          class="range"
          >{{
            price.max
              .toLocaleString("en")
              .split(",")
              .join(".")
          }}
          {{ showUnit }}</span
        >

        <span v-else class="range"
          >{{
            price.min
              .toLocaleString("en")
              .split(",")
              .join(".")
          }}
          -
          {{
            price.max
              .toLocaleString("en")
              .split(",")
              .join(".")
          }}
          {{ showUnit }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "itemDescription",
  props: {
    description: {
      required: true,
      type: Object
    },
    hover: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showUnit() {
      if (
        this.description.mun_unit === "komad" ||
        this.description.mun_unit === "komada"
      ) {
        return this.$t("item.items");
      } else if (
        this.description.mun_unit === "paket" ||
        this.description.mun_unit === "paketa"
      ) {
        return this.$t("item.package");
      }
      return this.description.mun_unit;
    }
  }
};
</script>

<style lang="scss" scoped>
.item-description-wrapper {
  font-family: Outfit;
  text-align: left;
  margin-bottom: 10px;
  cursor: pointer;

  .description-title {
    margin-top: 42px;
    margin-bottom: 25px;

    .title {
      font-weight: 500;
      font-style: Medium;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: 0%;

      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
      overflow-wrap: break-word;
      color: $blue-1000;
      margin-bottom: 10px;
    }
    .user {
      font-weight: 500;
      font-style: Medium;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: 0%;
      color: $gray-blue-1300;
    }
  }
  .description-title::first-letter {
    text-transform: uppercase;
  }

  .description-prices {
    .description-price {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      justify-content: space-between;
      margin-bottom: 12px;
      gap: 10px;

      .price {
        // color: $main-color;
        // font-style: normal;
        // font-weight: 800;
        // font-size: 13px;
        // line-height: 21px;
        // text-align: left;
        font-size: 13px;
        line-height: 21px;
        font-weight: 400;
        font-style: Regular;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: 0%;

        color: $gray-blue-1300;

        span {
          text-transform: uppercase;
        }
      }
      .range {
        font-weight: 400;
        font-style: Regular;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: 0%;

        color: $gray-blue-1300;
        text-align: right;
      }
    }
    .description-price:last-of-type {
      margin-bottom: 0;
    }
  }

  .description-prices.hover {
    margin-bottom: 10px;
    height: 51px;

    .price {
      font-size: 15px;
    }
  }

  .details {
    border-width: 1px 0px 1px 0px;
    border-style: solid;
    border-color: $gray-blue-800;
    padding: 25px 0;
    margin-bottom: 25px;
  }
  .description-expire {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;

    font-weight: 400;
    font-style: Regular;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0%;

    color: $blue-1000;

    .description-offer {
      // color: $text-color;
    }
    .description-expire-date {
      // color: #484848;
    }
  }
  .description-user {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 10px;

    .description-username {
      font-weight: 400;
      font-style: Regular;
      font-size: 18px;
      line-height: 100%;
      letter-spacing: 0%;

      color: $gray-blue-1300;
    }
    .description-rate-wrapper {
      margin-top: 5px;
    }
    .rate-title {
      // font-size: 13px;
      // line-height: 21px;
      // color: #484848;
      margin-right: 5px;
    }
    // .rate {
    //   color: $main-color;
    //   font-weight: bold;
    //   font-size: 13px;
    // }
  }
}
.main {
  min-height: 75px;
  color: $blue-1000;
  .description-price {
    margin-bottom: 15px;
  }
  .price {
    font-weight: 500;
    font-style: Medium;
    font-size: 30px;
    line-height: 100%;
  }
  .range {
    font-weight: 400;
    font-style: Regular;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0%;
  }
}

@media only screen and (max-width: 768px) {
  .item-description-wrapper {
    width: 55%;
    margin-bottom: 0;
    padding-right: 3px;
    .details {
      padding-top: 10px;
      padding-bottom: 0;
      border-bottom: 0px;
      margin-bottom: 0;
    }
    .description-title {
      margin-top: 10px;
      margin-bottom: 5px;

      .title {
        font-size: 18px;
      }
      .user {
        font-size: 13px;
      }
    }
    .description-expire {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: baseline;

      font-size: 14px;

      .description-offer {
        // color: $text-color;
        margin-bottom: 3px;
      }
      .description-expire-date {
        // color: #484848;
      }
    }

    .description-user {
      margin-bottom: 0px;
    }
    .description-rate-wrapper {
      font-size: 12px;
    }

    .description-prices {
      .description-price {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        justify-content: space-between;
        margin-bottom: 0px;
        gap: 10px;

        .price {
          font-size: 13px;
          line-height: 21px;

          color: $gray-blue-1300;
        }
        .range {
          font-size: 12px;
          line-height: 100%;
          letter-spacing: 0%;

          color: $gray-blue-1300;
          text-align: right;
        }
      }
      .description-price:last-of-type {
        margin-bottom: 0;
      }
    }
  }
  // old
  // .details {
  //   display: none !important;
  // }
  .main {
    display: none;
    min-height: 75px;

    color: $blue-1000;

    .description-price {
      margin-bottom: 15px;
    }
    .price {
      font-size: 24px;
      line-height: 100%;
    }
    .range {
      font-size: 18px;
      line-height: 100%;
      letter-spacing: 0%;
    }
  }
}
</style>
